import { TableCell, TableFooter, TableRow } from '@material-ui/core';
import _ from 'lodash';
import React from 'react';
import { dateRenderer, floatRenderer } from '../../../services/formatSvc';

const footerCellStyle = { fontWeight: 'bold', color: 'inherit', fontSize: 'inherit' };

export const getFooter = ({ renderData }) => {
  const getSumCell = (fieldName, isRenderFloat) => {
    let value = _.sumBy(renderData, fieldName);
    if (isRenderFloat) value = floatRenderer(value);

    return (
      <TableCell key={fieldName} style={footerCellStyle}>{ value }</TableCell>
    );
  };

  return (
    <TableFooter>
      <TableRow>
        <TableCell colSpan="2" align={'left'} style={{position: 'sticky', zIndex: 15, backgroundColor: '#fff', left: 0}} />
        <TableCell style={{ ...footerCellStyle, position: 'sticky', left: 170, zIndex: 15, backgroundColor: '#fff' }} colSpan="4">ИТОГО</TableCell>
        {getSumCell('fbBudget', true)}
        {getSumCell('sfBudget', true)}
        {getSumCell('fbProjBudget', true)}
        {getSumCell('sfProjBudget', true)}
        {getSumCell('projsCount')}
        <TableCell />
      </TableRow>
    </TableFooter>
  );
};
